import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import * as ValgTypes from '../Store/Valg/Types';
import { StamdataNordenHelgradModel } from '../Models/StamdataNordenHelgradModel';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import VeilederNordenDto from '../Models/VeilederNordenDto';
import { VeilederNordenAppState } from '../Store';
import VarighetTypeValg from '../Utilities/VarighetTypeValg';
import BetaleTypeValg from '../Utilities/BetaleTypeValg';
import { ResultatValg } from '../Store/Resultat/Types';
import { formatNumber, hentAntallDagerDetSkalRegnesStipendOgLanFor } from '../Utilities/Helpers';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface ResultatOwnProps {
    satser: StamdataNordenHelgradModel | null,
    valg: ValgTypes.ValgState,
    valuta: string,
    locale:string,
    visUtbetalingsPlanHandler: any,
}

type ResultatDisplayProps = ResultatOwnProps & MapStateToProps;

function Resultat(props: ResultatDisplayProps): JSX.Element {
    const { epiContext, resultat } = props;

    const [visVilkarAModal, setVisVilkarAModal] = useState(false);
    const [visUtbetalingsplan, setVisUtbetalingsplan] = useState(false);

    useEffect(() => {
        updateLiveMessage();
    }, []);
    function onVilkarAClick(): void {
        setVisVilkarAModal(true);
    }

    function onRequestLukkVilkarA(): void {
        setVisVilkarAModal(false);
    }

    function onVisUtbetalingsPlan(): void {
        if(visUtbetalingsplan) {
            setVisUtbetalingsplan(false);
            props.visUtbetalingsPlanHandler(false);
        } else {
            setVisUtbetalingsplan(true);
            props.visUtbetalingsPlanHandler(true);
        }
    }

    function getTitle(): JSX.Element | null {
        if(props.valg.aVarighet?.value === VarighetTypeValg.a1_hele) {
            return contentResolver(epiContext, "resultatTittelHeltAar");
        }
        return contentResolver(epiContext, "resultatTittelSemester");
    }

    function getUnderOverskrift(): JSX.Element | null {
        if(props.valg.aVarighet?.value === VarighetTypeValg.a1_hele) {
            return contentResolver(epiContext, "resultatTotaltTittel");
        }
        return contentResolver(epiContext, "resultatTotaltTittelSemester");
    }

    function hentSkolepengeBelop(): number {
        if(props.valg?.cSkolepengerBelop !== undefined && props.valg?.bBetale?.value === BetaleTypeValg.a1_ja)
            return props.valg.cSkolepengerBelop;

        return 0;
    }

    function hentUtregningTotal(): number {
        if(props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG !== undefined) {
            return Math.round((props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG * hentAntallDagerDetSkalRegnesStipendOgLanFor(props.valg.aVarighet?.value)) + hentSkolepengeBelop());
        }
        return 0;
    }

    function hentUtregningStipend(): number {
        if(props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG !== undefined) {
            return Math.round((props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG * hentAntallDagerDetSkalRegnesStipendOgLanFor(props.valg.aVarighet?.value)) * 0.4);
        }
        return 0;
    }

    function hentUtregningMaksLan(): number {
        if(props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG !== undefined) {
            return Math.round(((props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG * hentAntallDagerDetSkalRegnesStipendOgLanFor(props.valg.aVarighet?.value)) * 0.6) + hentSkolepengeBelop());
        }
        return 0;
    }

    return (
        <div className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine">
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--header">
                    <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                        {getTitle()}
                    </h3>
                </div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <div className="c-veileder__resultat-tekst">
                        <span>{formatNumber(hentUtregningTotal(), props.locale)}</span>
                        <span className="c-veileder__tekst c-veileder__tekst--postfix">&nbsp;{props.valuta}</span>
                    </div>
                    <p className="c-veileder__tekst c-veileder__tekst--tett">
                        {getUnderOverskrift()}
                    </p>
                </div>
            </div>
            <div className="c-veileder__panel-row c-veileder__panel-row-top-space">
                <div className="c-veileder__content"></div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <div className="c-veileder__resultat-tekst-overskrift">{contentResolver(epiContext, "resultatStipendTittel")}</div>
                    <div className="c-veileder__underresultat-tekst">
                        <span>{formatNumber(hentUtregningStipend(), props.locale)}</span>
                        <span className="c-veileder__tekst c-veileder__tekst--postfix">&nbsp;{props.valuta}</span>
                    </div>
                    <p className="c-veileder__tekst c-veileder__tekst--tett">
                        <span>{contentResolver(epiContext, "resultatStipendVilkarTekst")}</span>
                    </p>

                </div>
            </div>
            <div className="c-veileder__panel-row c-veileder__panel-row-bottom-space">
                <div className="c-veileder__content c-veileder__content--header"></div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <div className="c-veileder__resultat-tekst-overskrift">{contentResolver(epiContext, "resultatLanTittel")}</div>
                    <div className="c-veileder__underresultat-tekst">
                        <span>{formatNumber(hentUtregningMaksLan(), props.locale)}</span>
                        <span className="c-veileder__tekst c-veileder__tekst--postfix">&nbsp;{props.valuta}</span>
                    </div>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine" onClick={onVilkarAClick}>
                        {contentResolver(epiContext, "resultatVilkarStudieStotteLenkeTekst")}
                    </button>
                    <ModalCompontent
                        isOpen={visVilkarAModal}
                        onRequestClose={onRequestLukkVilkarA}
                        ariaCloseText={resolveRawText(epiContext, "resultatVilkarLukkStudieStottePopupAriaTekst")}
                    >
                        <ArticleContentComponent
                            headerinnhold={contentResolver(epiContext, "resultatVilkarStudieStotteTittel")}
                            contentinnhold={contentResolver(epiContext, "resultatVilkarStudieStotteTekst")}
                        />
                    </ModalCompontent>
                </div>
                <div className="c-veileder__content c-veileder__content--indented">
                    <button type="button" className={"c-knapp c-knapp--lenke c-knapp--fullwidth-ms c-knapp--centered c-knapp--icon-after c-knapp--pil-opp-hvit " + (resultat.visBetPlan ? "c-knapp--icon-reversed" : "")} onClick={onVisUtbetalingsPlan}>{contentResolver(epiContext, "resultatUtbetalingsPlanLenkeTekst")}</button>
                </div>
            </div>
        </div>
    )

}

interface MapStateToProps {
    epiContext: EpiContext<VeilederNordenDto>;
    resultat: ResultatValg;
}

export default connect(
    (state: VeilederNordenAppState, ownProps: ResultatOwnProps): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            resultat: state.resultat,
        };
    }
)(Resultat);